import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {Paginator} from "../../models/paginator";

export enum TableColumnType {
  DEFAULT, DATE, ICON, ACTIONS, BOOLEAN, COLOR, HTML
}

export interface TableColumn {
  key: string;
  isMasterKey?: boolean;
  title: string;
  type: TableColumnType;
}

export interface TableAction {
  icon: string;
  text?: string;
  color?: string;
  callback: () => {};
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  @Input()
  columns: TableColumn[];

  _rows = null;
  @Input()
  set rows(rows: any[]) {
    if ( !this._rows || rows.length != this._rows.length || (rows.length > 0 && rows.some((row, index) => JSON.stringify(row) !== JSON.stringify(this._rows[index])) ) ) {
      this._rows = rows;
      this.refresh();
    }
  };

  dataSource = null;

  @Input()
  paginator: Paginator<any>;

  @Output()
  onItemClicked = new EventEmitter<string>();

  @ViewChild(MatPaginator, {static: true}) paginatorElement: MatPaginator;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor() {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.dataSource = new MatTableDataSource(this._rows);

    //this.dataSource.paginator = this.paginatorElement;
    this.dataSource.sort = this.sort;
  }

  getColumnTitle(columnKey: string) {
    return this.columns.find(column => column.key === columnKey).title;
  }

  getColumnType(columnKey: string) {
    return this.columns.find(column => column.key === columnKey).type;
  }

  getColumnsTypes() {
    return TableColumnType;
  }

  isMasterKey(columnKey: string) {
    return this.columns.find(column => column.key === columnKey).isMasterKey;
  }

  getColumns() {
    return this.columns.map(column => column.key);
  }

  getDateFormatted(date: Date) {
    return date ? date.toLocaleString().replace('Invalid Date', '-') : '-';
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  reloadData() {
    this.ngOnInit();
  }

}
